import { render, staticRenderFns } from "./DeliveryBasisesManagement.vue?vue&type=template&id=ffdb6c22&"
import script from "./DeliveryBasisesManagement.vue?vue&type=script&lang=js&"
export * from "./DeliveryBasisesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports